// info-perfil.service.js
"use strict";

class infoPerfilService {
  constructor($http, $q, $window) {
    this.$window = $window;
    this.$http = $http;
    this.$q = $q;
    let last10Chars="";

    if($window.localStorage.getItem('sweno-customer-token-validation')!=null && $window.localStorage.getItem('sweno-customer-token-validation')!==undefined ) {
      last10Chars =  $window.localStorage.getItem('sweno-customer-token-validation').slice(-10);
    }

    this.url = {
      info: '/api/customer/profile?cont='+last10Chars
    };
    this.defer = undefined;
  }

  getInfo() {
    if (this.defer) {
      return this.defer.promise;
    }
    this.defer = this.$q.defer();
    this
      .$http
      .get(this.url.info)
      .then(data => this.defer.resolve(data.data))
      .catch(()=>this.defer.reject());
    return this.defer.promise;
  }
}

infoPerfilService.$inject = ["$http", "$q", "$window"];

export { infoPerfilService as INFO_PERFIL_SERVICE };
